import Typography from "@material-ui/core/Typography";
import { forwardRef, useEffect, useMemo } from "react";
import { styleGuide } from "theme";
import { SCROLL_OFFSET, SET_SELECTED_MENU_EVENT } from "../hero/HeroDesktop";
import { ITheme, useMediaQuery, useTheme } from "@material-ui/core";

interface IProps {
    cdnPath: string;
    isMobile: boolean;
    title: string;
    description: string;
    id: string;
}

const SectionF1LeagueSimple = forwardRef(({ cdnPath, isMobile, title, description, id }: IProps, ref: any) => {
    const theme: ITheme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.down("sm"));

    const background = useMemo(() => {
        return isMobile
            ? `${cdnPath}/banner_league_mobile.jpg`
            : sm
            ? `${cdnPath}/banner_league_tab.jpg`
            : `${cdnPath}/banner_league.jpg`;
    }, [isMobile, sm]);

    useEffect(() => {
        const sendSelectedMenu = () => {
            if (
                window.scrollY + SCROLL_OFFSET >= ref.current.offsetTop &&
                window.scrollY + SCROLL_OFFSET < ref.current.offsetTop + ref.current.clientHeight
            ) {
                window.dispatchEvent(new CustomEvent(SET_SELECTED_MENU_EVENT, { detail: id, bubbles: false }));
            }
        };

        window.addEventListener("scroll", sendSelectedMenu);

        return () => window.removeEventListener("scroll", sendSelectedMenu);
    }, [ref]);

    return (
        <div
            ref={ref}
            style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : sm ? "1fr 1fr" : "2fr 3fr",
                width: "100%",
                background: `url("${background}") no-repeat`,
                backgroundSize: "cover",
                alignItems: "end",
                justifyContent: "center",
                backgroundPositionX: isMobile ? "60%" : "center",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: styleGuide.spacing(0.5),
                    padding: isMobile
                        ? `120% ${styleGuide.spacing(2)}px ${styleGuide.spacing(8)}px ${styleGuide.spacing(2)}px`
                        : `47% ${styleGuide.spacing(2)}px`,
                    maxWidth: 420,
                    justifySelf: "center",
                }}
            >
                <Typography
                    style={{
                        ...(isMobile ? styleGuide.typography.heading : styleGuide.typography.title),
                        textAlign: isMobile ? "center" : "start",
                    }}
                >
                    {title}
                </Typography>
                <Typography style={{ ...styleGuide.typography.copyText, textAlign: isMobile ? "center" : "start" }}>
                    {description}
                </Typography>
            </div>
        </div>
    );
});

export default SectionF1LeagueSimple;
